import { CiLocationOn } from "react-icons/ci";
import { Link } from "react-router-dom";
import Star from "../SvgIcons/Star";
import Badge from "./Badge";
import ProductDetails from "./ProductTypeDetails";

const ProductCard = ({ product }) => {
  const { title, price, location, details, imageUrls, productType, type } =
    product;

  let link = "";
  switch (type) {
    case "Classified Ad":
      link = "/classified-ad-listing";
      break;
    case "Buy Now":
      link = "/buylisting";
      break;
    case "Auction":
      link = "/auction-listing-display";
      break;

    default:
      link = "/buylisting";
  }

  return (
    <div className="product-card card-shadow relative mb-5 w-60 overflow-hidden border border-t-0 border-black border-opacity-25">
      <Badge text={"For Sale"} />
      <Link to={link}>
        <img
          src={imageUrls[0]}
          alt=""
          className="aspect-[2] w-full cursor-pointer object-cover"
        />
        <div className="bg-cardBackground p-2">
          <div className="my-[3px] flex flex-row items-center gap-1">
            <span className="font-pop text-sm font-semibold text-primary">
              R {price}
            </span>
          </div>
          <h4 className="h-12 w-4/5 cursor-pointer font-pop text-xs font-normal leading-5 text-black">
            {title}
          </h4>

          <div>
            <div className="my-1 flex flex-row items-center justify-between">
              <ProductDetails details={details} productType={productType} />
            </div>
            <div className="flex flex-col flex-wrap items-start justify-between">
              <div className="my-1 flex items-center font-pop text-xs font-normal text-black">
                <CiLocationOn className="mr-1 text-redBorder" /> {location}
              </div>
              <div className="end-timer font-pop text-xs">
                <span className="font-medium text-secondary">Ends in:-</span>{" "}
                <span className="text-black">12 Jan At 10:15</span>{" "}
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            className={`mt-2 flex w-full items-center justify-around border-t border-t-black border-opacity-25 bg-cardBackground py-2.5 font-pop text-sm font-semibold text-${
              type === "Classified Ad"
                ? "primary"
                : type === "Auction"
                ? "redBorder"
                : "blue"
            }`}
          >
            <span></span>
            <span>
              {type === "Classified Ad"
                ? "Classified Ad"
                : type === "Auction"
                ? "Bid Now"
                : "Buy Now"}
            </span>
            <Star className="h-5 w-5 cursor-pointer" />
          </button>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
